import React from 'react';
import SongLinks from './SongLinks';
import cover from "../assets/coverart/Katharsis.png"


export const Katharsis = () => {    

    return (
        <SongLinks 
        title={"Katharsis"} 
        coverArt={cover} 
        spotifyLink={"https://open.spotify.com/album/6B2dKoYWauh1tZcQhIWUKc"}
        spotifyPresaveLink={"https://add-it.feiyr.com/zebrablau/Katharsis"}
        appleMusicLink={"https://music.apple.com/de/album/katharsis-single/1811525764"} 
        appleMusicPresaveLink={undefined}
        youtubeMusicLink={"https://music.youtube.com/watch?v=_1X0pALnico"}
        youtubeLink={"https://www.youtube.com/watch?v=z6HAb7PJ9VQ"}
        tidalLink={"https://tidal.com/album/433121652"}
        amazonMusicLink={"https://music.amazon.com/tracks/B0F6Y7XLLF?marketplaceId=A1PA6795UKMFR9&musicTerritory=DE&ref=dm_sh_6r5aPoNgGzeQ5FJenMztUZCEj"}
        bandcampLink={"https://mondwild.bandcamp.com/track/katharsis"}
        releaseDate={"2025-05-30T00:00:00+02:00"}/>
    );
}